"use strict";
var _a, _b, _c, _d, _e, _f, _g;
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTmaPlatform = isTmaPlatform;
exports.isInTMA = isInTMA;
exports.isInTelegramBrowser = isInTelegramBrowser;
exports.sendExpand = sendExpand;
exports.sendOpenTelegramLink = sendOpenTelegramLink;
exports.versionCompare = versionCompare;
const url_1 = require("./url");
const log_1 = require("./log");
const protocol_1 = require("../protocol");
const web_api_1 = require("./web-api");
let initParams = {};
try {
    let locationHash = location.hash.toString();
    initParams = urlParseHashParams(locationHash);
}
catch (e) { }
let tmaPlatform = 'unknown';
if (initParams === null || initParams === void 0 ? void 0 : initParams.tgWebAppPlatform) {
    tmaPlatform = (_a = initParams.tgWebAppPlatform) !== null && _a !== void 0 ? _a : 'unknown';
}
if (tmaPlatform === 'unknown') {
    const window = (0, url_1.getWindow)();
    tmaPlatform = (_d = (_c = (_b = window === null || window === void 0 ? void 0 : window.Telegram) === null || _b === void 0 ? void 0 : _b.WebApp) === null || _c === void 0 ? void 0 : _c.platform) !== null && _d !== void 0 ? _d : 'unknown';
}
let webAppVersion = '6.0';
if (initParams === null || initParams === void 0 ? void 0 : initParams.tgWebAppVersion) {
    webAppVersion = initParams.tgWebAppVersion;
}
if (!webAppVersion) {
    const window = (0, url_1.getWindow)();
    webAppVersion = (_g = (_f = (_e = window === null || window === void 0 ? void 0 : window.Telegram) === null || _e === void 0 ? void 0 : _e.WebApp) === null || _f === void 0 ? void 0 : _f.version) !== null && _g !== void 0 ? _g : '6.0';
}
/**
 * Returns true if the app is running in TMA on the specified platform.
 * @param platforms
 */
function isTmaPlatform(...platforms) {
    return platforms.includes(tmaPlatform);
}
/**
 * Returns true if the app is running in TMA.
 */
function isInTMA() {
    var _a;
    return tmaPlatform !== 'unknown' || !!((_a = (0, url_1.getWindow)()) === null || _a === void 0 ? void 0 : _a.TelegramWebviewProxy);
}
/**
 * Returns true if the app is running in the Telegram browser.
 */
function isInTelegramBrowser() {
    var _a;
    const isTelegramWebview = !!((_a = (0, url_1.getWindow)()) === null || _a === void 0 ? void 0 : _a.TelegramWebview);
    return (isInTMA() || isTelegramWebview) && tmaPlatform === 'unknown';
}
/**
 * Expand the app window.
 */
function sendExpand() {
    postEvent('web_app_expand', {});
}
/**
 * Opens link in TMA or in new tab and returns a function that closes the tab.
 * @param link The link to open.
 * @param fallback The function to call if the link can't be opened in TMA.
 */
function sendOpenTelegramLink(link, fallback) {
    const url = new URL(link);
    if (url.protocol !== 'http:' && url.protocol !== 'https:') {
        if (fallback) {
            return fallback();
        }
        throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `Url protocol is not supported: ${url}`);
    }
    if (url.hostname !== 't.me') {
        if (fallback) {
            return fallback();
        }
        throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `Url host is not supported: ${url}`);
    }
    const pathFull = url.pathname + url.search;
    if (isIframe() || versionAtLeast('6.1')) {
        postEvent('web_app_open_tg_link', { path_full: pathFull });
    }
    else {
        (0, web_api_1.openLinkBlank)('https://t.me' + pathFull);
    }
}
function isIframe() {
    try {
        const window = (0, url_1.getWindow)();
        if (!window) {
            return false;
        }
        return window.parent != null && window !== window.parent;
    }
    catch (e) {
        return false;
    }
}
function postEvent(eventType, eventData) {
    try {
        const window = (0, url_1.getWindow)();
        if (!window) {
            throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `Can't post event to parent window: window is not defined`);
        }
        if (window.TelegramWebviewProxy !== undefined) {
            (0, log_1.logDebug)('postEvent', eventType, eventData);
            window.TelegramWebviewProxy.postEvent(eventType, JSON.stringify(eventData));
        }
        else if (window.external && 'notify' in window.external) {
            (0, log_1.logDebug)('postEvent', eventType, eventData);
            window.external.notify(JSON.stringify({ eventType: eventType, eventData: eventData }));
        }
        else if (isIframe()) {
            const trustedTarget = '*';
            const message = JSON.stringify({ eventType: eventType, eventData: eventData });
            (0, log_1.logDebug)('postEvent', eventType, eventData);
            window.parent.postMessage(message, trustedTarget);
        }
        else {
            throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `Can't post event to TMA`);
        }
    }
    catch (e) {
        (0, log_1.logError)(`Can't post event to parent window: ${e}`);
    }
}
function urlParseHashParams(locationHash) {
    locationHash = locationHash.replace(/^#/, '');
    let params = {};
    if (!locationHash.length) {
        return params;
    }
    if (locationHash.indexOf('=') < 0 && locationHash.indexOf('?') < 0) {
        params._path = urlSafeDecode(locationHash);
        return params;
    }
    let qIndex = locationHash.indexOf('?');
    if (qIndex >= 0) {
        let pathParam = locationHash.substr(0, qIndex);
        params._path = urlSafeDecode(pathParam);
        locationHash = locationHash.substr(qIndex + 1);
    }
    let query_params = urlParseQueryString(locationHash);
    for (let k in query_params) {
        params[k] = query_params[k];
    }
    return params;
}
function urlSafeDecode(urlencoded) {
    try {
        urlencoded = urlencoded.replace(/\+/g, '%20');
        return decodeURIComponent(urlencoded);
    }
    catch (e) {
        return urlencoded;
    }
}
function urlParseQueryString(queryString) {
    let params = {};
    if (!queryString.length) {
        return params;
    }
    let queryStringParams = queryString.split('&');
    let i, param, paramName, paramValue;
    for (i = 0; i < queryStringParams.length; i++) {
        param = queryStringParams[i].split('=');
        paramName = urlSafeDecode(param[0]);
        paramValue = param[1] == null ? null : urlSafeDecode(param[1]);
        params[paramName] = paramValue;
    }
    return params;
}
function versionCompare(v1, v2) {
    if (typeof v1 !== 'string')
        v1 = '';
    if (typeof v2 !== 'string')
        v2 = '';
    let v1List = v1.replace(/^\s+|\s+$/g, '').split('.');
    let v2List = v2.replace(/^\s+|\s+$/g, '').split('.');
    let a, i, p1, p2;
    a = Math.max(v1List.length, v2List.length);
    for (i = 0; i < a; i++) {
        p1 = parseInt(v1List[i]) || 0;
        p2 = parseInt(v2List[i]) || 0;
        if (p1 === p2)
            continue;
        if (p1 > p2)
            return 1;
        return -1;
    }
    return 0;
}
function versionAtLeast(ver) {
    return versionCompare(webAppVersion, ver) >= 0;
}
